import { Card } from "@/components/Shared/Card";
import { Separator } from "@/components/ui/separator";
import { Tab, TabView } from "@/components/ui/Tabbable";
import { FlujoForm } from "./2_Flujo.form";
import { FormsView } from "./4_Informes.form";
import { ResumenProyecto } from "./3_Resumen.form";
import { useApi } from "@/hooks/useApi";
import { useParams } from "react-router-dom";

export function ProyectoView() {
	const path = useParams() as { proyectoId: string; };
	const api = useApi();
	const query = api.useQuery("get", "/v1/Empresa/Proyectos/{idProyecto}", {
		params: {
			path: {
				idProyecto: path.proyectoId,
			},
		},
	});

	return (
		<Card style={{ flex: "1", display: "flex", flexDirection: "column" }}>
			<h1 className="text-xl font-bold">Motor eléctrico:</h1>
			<Separator />

			{query.data && (
				<TabView style={{ flex: "1" }}>
					<Tab title="Flujo" id="flujo">
						<FlujoForm proyecto={query.data} idProyecto={path.proyectoId} />
					</Tab>
					<Tab title="Resumen" id="resultados">
						<ResumenProyecto proyecto={query.data} />
					</Tab>
					<Tab title="Informes" id="informes">
						<FormsView idProyecto={path.proyectoId} />
					</Tab>
				</TabView>
			)}
		</Card>
	);
}
